package com.fireavert.menu.client.presentation

import com.fireavert.common.Try

interface MenuNotificationRepository {
    suspend fun getDashboardNotification(tryRefresh: Boolean = true): Try<Int>
    suspend fun getPropertiesNotification(tryRefresh: Boolean = true): Try<Int>
}